import React, { useEffect, Fragment } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { push } from 'connected-react-router';
import Image, { WrapperImages } from 'components/Image';
import iconProfile from 'assets/img/icons/profile.svg';
import { Spinner } from 'triider-components';
import { Creators as TaskCreators } from 'store/ducks/task';
import { Creators as UiCreators } from 'store/ducks/ui';
import { Creators as FormCreators } from 'store/ducks/serviceForm';
import { routes } from 'config/routes';

import { gaSendEvent } from '../../../utils/analytics';

import {
  Container,
  TitleBox,
  TaskStyled,
  Label,
  Name,
  Date,
  Labels,
  Quotes,
  QuotesText,
  LinkStyled,
  ImageEmpty,
  Title,
  Desc,
  OpenFormCta,
} from './styles';


const OpenTasksList = ({
  userDashs, _push, isLoading, _openForm, _finishForm,
}) => {
  const makeLabel = (color, name) => (
    <Label color={color}>{name}</Label>
  );

  const getLabels = task => (
    <Fragment>
      {task.status.toLowerCase() === 'open' && makeLabel('red','Não Contratado')}
      {!!task.unread_messages && task.unread_messages > 0 && ( makeLabel('blue', 'Mensagem não lida') )}
      {task.status.toLowerCase() === 'hired' && makeLabel('success', 'Contratado') }
      {task.status.toLowerCase() === 'paid' && makeLabel('success', 'Pago')}
      {task.status.toLowerCase() === 'charged' && makeLabel('red', 'Pagamento Pendente')}
      {task.status.toLowerCase() === 'canceled' && makeLabel('red', 'Cancelado')}
      {task.status.toLowerCase() === 'done' && makeLabel('success', 'Finalizado')}
    </Fragment>
  );

  const goToDetails = (task) => {
    const { id } = task;
    _push(`${routes.taskDetails.replace(':taskId', id)}/orcamentos`);
  };

  const Task = ({ task }) => (
    <TaskStyled onClick={() => goToDetails(task)}>
      <Labels>{getLabels(task)}</Labels>
      <Name>{task.service_name}</Name>
      <Date>{moment(task.created).format('DD/MM')}</Date>
      <Quotes>
        <WrapperImages>
          {task.quotes.slice(0, 3).map(quote => (
            <Image
              key={`quote-${quote.id}`}
              src={quote.profile_picture || iconProfile}
              alt={quote.user_name}
              size="xsmall"
              rounded
            />
          ))}
          {task.quotes.length > 3 && (
            <Image size="xsmall" rounded>
              +
              {task.quotes.length - 3}
            </Image>
          )}
        </WrapperImages>
        <QuotesText withMargin={task.quotes.length ? 'margin' : ''}>
          {task.quotes.length ? `${task.quotes.length} Orçamentos` : 'Nenhum orçamento'}
        </QuotesText>
      </Quotes>
    </TaskStyled>
  );

  const renderTasks = taskList => (
    taskList && taskList.length > 0 ? (
      <Container>
        {taskList.map(task => (
          <Task task={task} key={task.id} />
        ))}
        <LinkStyled to={{ pathname: routes.taskList, state: { name: 'status', value: 'open,hired,charged' } }} onClick={() => gaSendEvent('meus_pedidos', 'painel')}>Ver Todos</LinkStyled>
      </Container>
    ) : (
      <Container>
        <ImageEmpty />
        <Title>Tudo em ordem por aqui!</Title>
        <Desc>Você não possui nenhum pedido aberto no momento.</Desc>
        <OpenFormCta
          onClick={() => _openForm({
            isOpen: true,
            isFormAddress: false,
            address: null,
            onFinish: _finishForm,
            selectedAddress: null,
          })}
        >
          Fazer pedido
        </OpenFormCta>
      </Container>
    )
  );

  return (
    <div>
      <TitleBox>Pedidos Abertos</TitleBox>
      { isLoading ? (
        <Container flex>
          <Spinner size="larger" />
        </Container>
      ) : (
        renderTasks(userDashs.dashTasksList)
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  userDashs: state.dash.userDashs,
  // tasks: state.dash.tasks,
});

const mapDispatchToProps = {
  // _getTasks: TaskCreators.getTasksRequest,
  // _getFilters: TaskCreators.getTasksFiltersRequest,
  _push: push,
  _openForm: FormCreators.openForm,
  _finishForm: FormCreators.finishFormRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OpenTasksList);
